import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

// Load reducers
import * as FormReducers from './form/reducer'
import * as AuthReducers from './auth/reducer'
import * as CrudReducers from './crud/reducer'
import * as DataTableReducers from './datatable/reducer'
import * as UserReducers from './user/reducer'
import * as ProjectReducers from './project/reducer'
import * as OrganizationReducers from './organization/reducer'
import * as ProductReducers from './product/reducer'
import * as TaskTypeReducers from './taskType/reducer'
import * as TaskReducers from './task/reducer'
import * as OrderReducers from './order/reducer'
import * as ContactReducers from './contact/reducer'
import * as PeopleReducers from './people/reducer'
import * as ArticleReducers from './article/reducer'
import * as EventReducers from './event/reducer'
import * as InterviewReducers from './interview/reducer'
import * as CoordinationReducers from './coordination/reducer'
import * as NoteReducers from './note/reducer'
import * as OrganizationViewReducers from './organizationView/reducer'

export default Object.assign(
  {},
  FormReducers,
  AuthReducers,
  CrudReducers,
  UserReducers,
  ProjectReducers,
  OrganizationReducers,
  ProductReducers,
  DataTableReducers,
  TaskTypeReducers,
  TaskReducers,
  OrderReducers,
  ContactReducers,
  PeopleReducers,
  ArticleReducers,
  EventReducers,
  InterviewReducers,
  CoordinationReducers,
  NoteReducers,
  OrganizationViewReducers,
  { routing: routerReducer }
)
